export default "__VITE_ASSET__DWR1cBE0__"